import React from 'react';
import StatusPageLayout from '../components/StatusPageLayout';
import peepLostSrc from '../images/peep-lost.svg';

const NotFoundView = () => (
	<StatusPageLayout
		pageTitle='Page not found'
		imageSrc={peepLostSrc}
		title='Nothing here'
		description='This page may have been deleted. Check the URL.'
	/>
);

export default NotFoundView;
